import { Component, Inject, OnDestroy, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { AdvertService } from '@/services/common/advert.service';
import { MatDialogRef } from '@angular/material/dialog';
import { truncateName } from '../../../../helpers';
import { Advert } from 'interfaces/common';

@Component({
  selector: 'app-quick-view-dialog',
  templateUrl: './quick-view-dialog.component.html',
  styleUrls: ['./quick-view-dialog.component.scss'],
})
export class QuickViewDialogComponent implements OnInit, OnDestroy {
  //Store Data
  product?: Advert;
  id!: string | null;
  selectedImage!: string;
  image!: string;
  zoomImage!: string;

  //Subscriptions
  private subDataOne: Subscription = Subscription.EMPTY;
  private subParam: Subscription = Subscription.EMPTY;

  constructor(
    private advertService: AdvertService,
    @Inject(MAT_DIALOG_DATA) public shortId: number,
    private router: Router,
    private dialogRef: MatDialogRef<QuickViewDialogComponent>
  ) {}

  ngOnInit(): void {
    this.getSingleProductById(this.shortId);
  }

  getSingleProductById(id: number) {
    this.subDataOne = this.advertService.getAdvertByShortId(id).subscribe(
      res => {
        if (res.success) {
          this.product = res.data;
          this.selectedImage =
            this.product?.images && this.product?.images?.length
              ? this.product.images[0]
              : '';
          this.setDefaultImage();
        }
      },
      err => console.log(err)
    );
  }

  public selectTitle() {
    this.dialogRef.close();
    if (this.product)
      this.router.navigate(['/ad-details', this.product.shortId]);
  }

  private setDefaultImage() {
    this.image =
      this.product?.images && this.product?.images?.length
        ? this.product.images[0]
        : '/assets/images/placeholder/test.png';
    this.zoomImage = this.image;
  }

  // TODO: Consider transforming this to a pipe
  truncateAdvertName(name: string) {
    return truncateName(name);
  }

  ngOnDestroy() {
    this.subDataOne.unsubscribe();
    this.subParam.unsubscribe();
  }
}
